import { gql } from '@apollo/client'
import { ChecklistFragments } from './fragments'

export const CHECKLIST_QUERY = gql`
  query Checklist($id: ID!) {
    checklist(id: $id) {
      id
      title
      active
      mandatory
      createdAt
      updatedAt
      items {
        id
        text
        done
      }
      user {
        id
        fullName
      }
    }
  }
`

export const USER_CHECKLISTS = gql`
  query AllChecklists($user: ID, $mandatoryOnly: Boolean = false) {
    allChecklists(user: $user, active: true, mandatoryOnly: $mandatoryOnly) {
      edges {
        node {
          id
          title
          active
          mandatory
          createdAt
          updatedAt
          items {
            id
            text
            done
          }
        }
      }
    }
  }
`

export const COMPANY_CHECKLISTS = gql`
  query CompanyChecklists($user: ID, $date: Date, $noResponseOnly: Boolean) {
    allChecklists(user: $user, date: $date, active: $noResponseOnly) {
      edges {
        node {
          id
          title
          active
          mandatory
          createdAt
          updatedAt
          items {
            id
            text
            done
          }
          user {
            id
            fullName
          }
        }
      }
    }
  }
`

export const CHECKLIST_TEMPLATES_QUERY = gql`
  query AllChecklistTemplates {
    allChecklistTemplates {
      edges {
        node {
          ...shallowChecklistTemplateInfo
        }
      }
    }
  }
  ${ChecklistFragments.shallowChecklistTemplateInfo}
`

export const CHECKLIST_TEMPLATE_QUERY = gql`
  query ChecklistTemplate($id: ID!) {
    checklistTemplate(id: $id) {
      ...checklistTemplateInfo
    }
  }
  ${ChecklistFragments.checklistTemplateInfo}
`
